import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Vuetify from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";
import "vue-scroll-picker/dist/style.css"
import VueScrollPicker from "vue-scroll-picker"

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
Vue.use(VueSlickCarousel);

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
Vue.use(require("vue-jalali-moment"));

import "core-js/stable";
import "regenerator-runtime/runtime";

Vue.use(VuePersianDatetimePicker, {
  name: "custom-date-picker",
  props: {
    inputFormat: "YYYY-MM-DD",
    format: "jYYYY-jMM-jDD",
    editable: false,
    inputClass: "form-control my-custom-class-name",
    placeholder: "",
    altFormat: "YYYY-MM-DD",
    color: "#00FFFF",
    autoSubmit: true
  },
});
Vue.use(VueScrollPicker)

const vuetifyOptions = {
  rtl: true,
  dark: true,
  icons: {
    iconfont: "mdi",
  },
};

Vue.use(Vuetify);

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
  vuetify: new Vuetify(vuetifyOptions),
}).$mount("#app");
